import classNames from "classnames";

import { Label } from "../Label";

import styles from "./CardSelector.module.scss";

export interface CardSelectorOption {
  id: string;
  title: string;
  description: string;
}

export interface CardSelectorProps {
  selectedId: string;
  options: CardSelectorOption[];
  onChange: (id: string) => void;
  label?: string;
}

export const CardSelector: React.FC<CardSelectorProps> = ({ options, selectedId, onChange, label }) => {
  return (
    <div>
      {label && <Label>{label}</Label>}
      <div className={styles.cardSelector}>
        {options.map((option) => (
          <div
            key={option.id}
            className={classNames(styles.card, { [styles.active]: selectedId === option.id })}
            onClick={() => onChange(option.id)}
          >
            <div>
              <h3 className={styles.title}>{option.title}</h3>
              <p className={styles.description}>{option.description}</p>
            </div>
            <div className={styles.radioContainer}>
              <input type="radio" value={option.id} className={styles.radio} />
              <span className={styles.customRadio} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
